import React from 'react';
import { useHistory } from 'react-router-dom';
import StripeCheckout from 'react-stripe-checkout';
import Layout from '../../Layout/Layout';
import PricingCard from '../../public/Pricing/PricingCard';
import { PRICING_PLANS } from '../../public/Pricing/pricingPlans';
import '../../public/Pricing/Pricing.css';
import { useGlobalContext } from '../../UserContext/UserContext';

const STRIPE_KEY = 'pk_test_51OZJgYATvuf3fMYPlyFpz9SQQ2IZ1lw0wpVhgybcP6cLkK2ygtNuOWHT6yMdzStR8Vu6YBqQ0KI2XvKZ3eqUzKoX00dZRJmYAn';

const PAID_PLANS = PRICING_PLANS.filter((plan) => plan.price > 0);

const Subscription = () => {
    const { userToken } = useGlobalContext();
    const loggedUserId = localStorage.getItem('id');
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    const currentPlanId = userDetails?.limitId || 1;
    const history = useHistory();

    const handleRedirect = () => {
        if (!userToken) {
            history.push('/login');
        }
    };

    const handleToken = (token, plan) => {
        const body = {
            token,
            loggedUserId,
            product: {
                name: `${plan.name} Plan`,
                price: plan.price,
                productBy: 'NeuraTrader',
            },
        };

        fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        }).catch((err) => {
            console.log('Subscription failed:', err);
        });
    };

    const getPurchaseLabel = (plan) => {
        if (currentPlanId === plan.limitId) return 'Current plan';
        if (currentPlanId > plan.limitId) return 'Included in your plan';
        return `Upgrade to ${plan.name}`;
    };

    return (
        <Layout>
            <div className="pricing-page">
                <header className="pricing-page-header">
                    <span className="pricing-page-eyebrow">Subscription checkout</span>
                    <h1 className="pricing-page-title">Upgrade your account</h1>
                    <p className="pricing-page-subtitle">
                        Select a paid plan to increase your bot, monitor, and backtest limits.
                        {!userToken && ' Sign in to complete your purchase.'}
                    </p>
                </header>

                <div className="pricing-grid pricing-grid--checkout">
                    {PAID_PLANS.map((plan) => {
                        const isCurrentOrLower = currentPlanId >= plan.limitId;
                        const purchaseLabel = getPurchaseLabel(plan);

                        return (
                            <PricingCard
                                key={plan.id}
                                plan={plan}
                                currentPlanId={currentPlanId}
                                disabled={isCurrentOrLower}
                                purchaseLabel={purchaseLabel}
                                onSelect={handleRedirect}
                                checkoutWrapper={(button) => (
                                    <StripeCheckout
                                        stripeKey={STRIPE_KEY}
                                        token={(token) => handleToken(token, plan)}
                                        name={`${plan.name} Plan`}
                                        amount={plan.price * 100}
                                        shippingAddress
                                        billingAddress={false}
                                        disabled={!userToken || isCurrentOrLower}
                                    >
                                        {button}
                                    </StripeCheckout>
                                )}
                            />
                        );
                    })}
                </div>

                <p className="pricing-page-note">
                    Need to compare all tiers including Free?{' '}
                    <a href="/pricing" className="text-primary">View full pricing</a>
                </p>
            </div>
        </Layout>
    );
};

export default Subscription;